import $axios from '@martyrs/src/modules/core/views/utils/axios-instance.js';
import { reactive } from 'vue';

const state = reactive({
  current: null,
  list: [],
  providers: [],
  methods: [],
  loading: false,
});

const actions = {
  async createPayment({ provider, amount, currency, description, capture, returnUrl, saveMethod, metadata }) {
    state.loading = true;
    try {
      const response = await $axios.post('/api/payments/create', {
        provider,
        amount: { value: amount, currency: currency || 'RUB' },
        description,
        capture,
        returnUrl,
        saveMethod,
        metadata,
      }, {
        headers: { 'Idempotency-Key': crypto.randomUUID() },
      });
      state.current = response.data;
      return response.data;
    } finally {
      state.loading = false;
    }
  },

  async capturePayment(paymentId) {
    const response = await $axios.post(`/api/payments/${paymentId}/capture`);
    state.current = response.data;
    return response.data;
  },

  async cancelPayment(paymentId) {
    const response = await $axios.post(`/api/payments/${paymentId}/cancel`);
    state.current = response.data;
    return response.data;
  },

  async refundPayment(paymentId, { amount, reason }) {
    const response = await $axios.post(`/api/payments/${paymentId}/refund`, {
      amount,
      reason,
    }, {
      headers: { 'Idempotency-Key': crypto.randomUUID() },
    });
    state.current = response.data;
    return response.data;
  },

  async getPayment(paymentId) {
    const response = await $axios.get(`/api/payments/${paymentId}`);
    state.current = response.data;
    return response.data;
  },

  async listPayments(params = {}) {
    state.loading = true;
    try {
      const response = await $axios.get('/api/payments', { params });
      state.list = response.data;
      return response.data;
    } finally {
      state.loading = false;
    }
  },

  async getProviders() {
    const response = await $axios.get('/api/payments/providers');
    state.providers = response.data;
    return response.data;
  },

  async listPaymentMethods() {
    state.loading = true;
    try {
      const response = await $axios.get('/api/payment-methods');
      state.methods = response.data;
      return response.data;
    } finally {
      state.loading = false;
    }
  },

  async deletePaymentMethod(_id) {
    await $axios.delete(`/api/payment-methods/${_id}`);
    state.methods = state.methods.filter(m => m._id !== _id);
    return true;
  },

  async setDefaultPaymentMethod(_id) {
    const response = await $axios.post(`/api/payment-methods/${_id}/default`);
    // Re-fetch to keep the list in correct order (default first)
    await this.listPaymentMethods();
    return response.data;
  },

  resetState() {
    state.current = null;
    state.list = [];
    state.methods = [];
    state.loading = false;
  },
};

export { state, actions };
